var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"act_layout"},[_c('van-slider',{attrs:{"bar-height":"4px","inactive-color":"#999","active-color":"#6e9f21","min":-200,"max":200},on:{"input":_vm.handleInput,"change":_vm.renderRealScene},model:{value:(_vm.bindingY),callback:function ($$v) {_vm.bindingY=$$v},expression:"bindingY"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }